var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          staticClass: "align-center"
        },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center flex-wrap",
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "mr-auto"
                },
                [
                  _c(
                    "gg-card-title",
                    {
                      staticClass: "pt-0 pb-0"
                    },
                    [_vm._v(_vm._s(_vm.app))]
                  ),
                  _vm.server
                    ? _c(
                        "div",
                        {
                          staticClass: "apps__muted text-caption"
                        },
                        [
                          _vm._v(" On "),
                          _c(
                            "router-link",
                            {
                              staticClass: "apps__link",
                              attrs: {
                                to: {
                                  name: "hosting_kvm_info",
                                  params: {
                                    hostingid: _vm.serviceId
                                  }
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.server.name))]
                          ),
                          _vm.server.ip && _vm.server.ip !== "—"
                            ? [_vm._v(" · " + _vm._s(_vm.server.ip))]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    tile: "",
                    outlined: "",
                    color: "primary",
                    to: {
                      name: "applications"
                    }
                  }
                },
                [_vm._v("Back to applications")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("applications-operations", {
        attrs: {
          "service-id": _vm.serviceId
        },
        on: {
          done: _vm.onOperationDone
        }
      }),
      _c(
        "gg-card",
        [
          _c(
            "gg-card-text",
            {
              staticClass: "pa-4"
            },
            [
              !_vm.server && !_vm.lookupFailed
                ? _c(
                    "div",
                    {
                      staticClass: "py-6 text-center",
                      attrs: {
                        role: "status"
                      }
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          color: "primary",
                          size: "32",
                          width: "3",
                          "aria-hidden": "true"
                        }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "apps__sr"
                        },
                        [_vm._v("Loading…")]
                      )
                    ],
                    1
                  )
                : !_vm.server
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mb-0 apps__alert",
                      attrs: {
                        type: "warning",
                        dense: "",
                        text: ""
                      }
                    },
                    [
                      _vm._v(
                        " This server isn't a Docker server in your account. "
                      )
                    ]
                  )
                : _vm.unavailable
                ? _c(
                    "p",
                    {
                      staticClass: "apps__muted mb-0"
                    },
                    [_vm._v(_vm._s(_vm.unavailable))]
                  )
                : _c("kvm-docker-stacks", {
                    attrs: {
                      "service-id": _vm.serviceId,
                      start: "manage",
                      app: _vm.app,
                      "refresh-key": _vm.refreshKey,
                      "finished-ops": _vm.finishedOps
                    },
                    on: {
                      operation: _vm.onOperation,
                      exit: function exit($event) {
                        return _vm.$router.push({
                          name: "applications"
                        })
                      }
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }